module.exports = __webpack_public_path__ + "static/media/icon51.f6f9b36f.jpg";